import React from 'react';
import PropTypes from 'prop-types';

import TextCell from 'app/components/data-table/TextCell';
import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

export default function PipelineCell({ writekey }) {
  const { pipelinesByWritekey } = useEventDebuggerTableContext();

  const pipelineName = pipelinesByWritekey[writekey] ?? writekey;

  return <TextCell text={pipelineName} />;
}

PipelineCell.propTypes = {
  writekey: PropTypes.string.isRequired,
};
